export default __webpack_public_path__ + "static/media/carousel.6469675b.jpg";